import React, {Component} from 'react'
import Newsletter from "./Newsletter";
import AplikacjaMobilna from "./AplikacjaMobilna";
import Footer from "../../shared/Footer";
import AdminService from "../../admin/adminComponents/AdminService";

export default class Strona extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: '',
            loading: true
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        AdminService.getStronaById(this.props.match.params.id)
            .then(function (response) {
                let res = response.data;
                this.setState({data: res, loading: false})
            }.bind(this)).catch(err => {
            console.log(err)
        })
    }

    componentWillReceiveProps() {
        this.setState({loading: true});
        window.scrollTo(0, 0);
        setTimeout(
            function () {
                AdminService.getStronaById(this.props.match.params.id)
                    .then(function (response) {
                        let res = response.data;
                        this.setState({data: res, tytul: res.tytul, tresc: res.tresc, loading: false})
                    }.bind(this)).catch(err => {
                    console.log(err)
                })
            }
                .bind(this),
            500
        );
    }

    render() {
        return (
            <div>
                <div className="wynajemNaglowek przerywnik">
                    <div className="container text-center">
                        <h2><b>Nasza działalność opiera się na jasnych zasadach </b></h2>
                        <h4>Staramy się zawsze informować Państwa o najnowszych wydarzeniach</h4>
                    </div>
                </div>
                {this.state.loading ?
                    <div style={{
                        paddingTop: 200,
                        paddingBottom: 200,
                        textAlign: 'center',
                        color: '#58b13d',
                        background: '#efefef'
                    }}>
                        <div className="loaderDim"><i className="fa fa-spinner fa-pulse fa-2x fa-fw"> </i></div>
                    </div> :
                    <div className="panelPaddingMobilka"
                         style={{background: '#efefef', paddingTop: '25px', paddingBottom: '25px'}}>
                        <div className="container ramka" style={{background: '#fff'}}>
                            <div className="aktualnosci">
                                <div className="row">
                                    <div className="col-sm-12 text-left" style={{paddingTop: 25}}>
                                        <h2 className="text-center"
                                            style={{fontWeight: 'bold'}}>{this.state.data.tytul}</h2>
                                        <hr/>
                                        <div style={{margin: 25}}>
                                            <div style={{minHeight: 300}}
                                                 dangerouslySetInnerHTML={{__html: this.state.data.tresc}}></div>
                                        </div>
                                        <hr/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                {/*<Newsletter/>*/}
                {/*<AplikacjaMobilna/>*/}
                <Footer/>
            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./src/components/home/homeComponents/Strona.js